export const glassCard = {
    backgroundColor: 'rgba(255,255,255,0.04)',
    borderRadius: '16px',
    border: '1px solid rgba(255,255,255,0.06)',
    padding: '16px',
};

export const ACCENT = '#76A9AC';
export const ACCENT_DARK = '#1f7a7a';
export const ACCENT_GLOW = 'rgba(31,122,122,0.35)';

export const TEXT_PRIMARY = 'rgba(255,255,255,0.87)';
export const TEXT_SECONDARY = 'rgba(255,255,255,0.6)';
export const TEXT_TERTIARY = 'rgba(255,255,255,0.45)';
export const TEXT_DISABLED = 'rgba(255,255,255,0.38)';
export const TEXT_HINT = 'rgba(255,255,255,0.25)';

export const SURFACE_BORDER = 'rgba(255,255,255,0.08)';
export const SURFACE_HOVER = 'rgba(255,255,255,0.06)';
export const SURFACE_ACTIVE = 'rgba(255,255,255,0.10)';

export const STATUS_WON = '#66BB6A';
export const STATUS_LOST = '#E57373';
export const STATUS_OPEN = ACCENT;

export const DIALOG_BG = '#0f1b2e';
export const DIALOG_PAPER = {
    backgroundColor: '#0f1b2e',
    backgroundImage: 'none',
    borderRadius: '16px',
    border: '1px solid rgba(255,255,255,0.08)',
    maxWidth: 400,
    width: '100%',
    mx: 2,
};

export const TYPE_SCALE = {
    xs: '0.72rem',
    sm: '0.8rem',
    md: '0.9rem',
    lg: '1rem',
    xl: '1.2rem',
    '2xl': '1.5rem',
};

export const noMotion = {
    '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
};
